import { Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutEdiStopProgress extends Layout {
    panelStopHeader: Panel;
}
